"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _videoTileDidUpdateHandler = require("./videoTileDidUpdateHandler");
Object.keys(_videoTileDidUpdateHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _videoTileDidUpdateHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _videoTileDidUpdateHandler[key];
    }
  });
});